// extracted by mini-css-extract-plugin
export default {"body":"gamescard_body__Jumzq","desc":"gamescard_desc__wyAfh"};